import React, { useEffect, useState } from "react";
import { shallow } from "zustand/shallow";
import { Flex, Text, Button, Divider } from "@mantine/core";
import axios from "axios";

import ViewTitle from "@components/Microsite/ViewTitle";
import DealerVerification from "./DealerVerification";
import useAppStore from "@components/Microsite/microsite-store";
import RideChallengeHeader from "./RideChallengeHeader";
import UnverifiedItem from "./UnverifiedItem";

export default function VehicleVerificationView() {
  const [dealerView, setDealerView] = useState(false);
  const [dealerCodeData, setDealerCodeData] = useState(null);
  const [unverifiedData, setUnverifiedData] = useState([]);

  const {
    setActiveStep,
    verificationCode,
    coords,
    email,
    phone,
    location,
    user,
    entityInfo,
  } = useAppStore(
    (state) => ({
      coords: state.coords,
      user: state.user,
      verificationCode: state.verificationCode,
      setActiveStep: state.setActiveStep,
      location: state.location,
      email: state.email,
      phone: state.phone,
      entityInfo: state.entityInfo,
    }),
    shallow
  );

  const isVehicleDataEffort = entityInfo.is_vehicle_data_effort;

  useEffect(() => {
    if (verificationCode) {
      setDealerCodeData(verificationCode);
      setDealerView(true);
      fetchUser();
    }
  }, []);

  function fetchUser() {
    const req = {
      ...coords,
      location_id: location?.id,
      campaign_effort_id: entityInfo.campaign_effort_id,
      user_id: user?.id,
    };

    if (email) req.email = email;
    if (phone) req.mobile_phone = phone;

    axios
      .post(`/ride-challenge/retrieve-unverified-readings/`, req)
      .then(({ data }) => {
        const res = data.response;
        const matchingEfforts = res.filter(
          (f) => f.campaign_effort_id === entityInfo.campaign_effort_id
        );
        if (matchingEfforts.length) {
          setUnverifiedData(matchingEfforts);
        } else {
          setActiveStep("dashboard");
        }
      })
      .catch((err) => {});
  }

  if (dealerView) {
    if (!dealerCodeData) {
      return (
        <div>
          <RideChallengeHeader />
          <ViewTitle
            title={"Verification"}
            subtitle={`Dealer view verification`}
          />
          <DealerVerification
            setDealerCodeData={(e) => {
              setDealerCodeData(e);
              fetchUser();
            }}
            codeVerificationData={{
              ...coords,
              user_location_id: user?.user_location_id,
              campaign_effort_id: entityInfo.campaign_effort_id,
              location_id: location?.id,
              user_id: user?.id,
            }}
          />
        </div>
      );
    }

    return (
      <div>
        <RideChallengeHeader />
        {unverifiedData.map((m, i) => (
          <div key={m.id}>
            <UnverifiedItem
              info={m}
              dealerCodeData={dealerCodeData}
              additionalReqData={{
                ...coords,
                location_id: location?.id,
                verifier_remote_code_id: dealerCodeData.id,
                campaign_effort_id: entityInfo.campaign_effort_id,
              }}
              fetchUser={fetchUser}
              verificationCode={verificationCode}
              isVehicleDataEffort={isVehicleDataEffort}
            />
            {i < unverifiedData.length - 1 && <Divider mt="lg" mb="lg" />}
          </div>
        ))}
      </div>
    );
  }

  return (
    <div>
      <RideChallengeHeader />
      <ViewTitle
        title={"Verification"}
        subtitle={`Let's get everything verified`}
      />
      <div>
        <Text c="white" align="center">
          Please find an authorized dealership validator to complete the next
          steps.
        </Text>
        <Flex justify="center" mt="xl">
          <Button size="xs" onClick={() => setDealerView(true)}>
            Found a validator/I'm the validator
          </Button>
        </Flex>
      </div>
    </div>
  );
}
